import { TableSearch } from "ui/components/Table/TableSearch";
import { memo } from "react";
import { initialDataWithPagination } from "services/api/consts";
import {
  USER_SEARCH_COLUMNS,

} from "./consts";
import { UserSearchResultsProps } from "./types";

const UserSearchResults: React.FC<UserSearchResultsProps> = (props) => {
  const {
    searchResults,
    selectedRows,
    isLoading,
    onRowClick,
    onPaginationChange,
    onSelectedChange,
    onEmailClick,
    onPhoneClick,
    onGoogleMapClick,
  } = props;


  return (
    <>
      <TableSearch
        columns={USER_SEARCH_COLUMNS(onEmailClick, onPhoneClick, onGoogleMapClick)}
        data={searchResults.data}
        selectedRows={selectedRows}
        pagination={
          searchResults.pagination || initialDataWithPagination.pagination
        }
        selectableRows={false}
        onPaginationChange={onPaginationChange}
        onSelectedChange={onSelectedChange}
        isLoading={isLoading}
        onRowClick={onRowClick}
      />
    </>
  );
};
export default memo(UserSearchResults);
